<app-header></app-header>
<main id="main-content" style="min-height: calc(100vh - 400px);">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
